{
  "expo": {
    "name": "RecordOS",
    "slug": "recordos",
    "owner": "annulus-technology-pvt-ltd",
    "version": "1.0.17",
    "orientation": "portrait",
    "icon": "./assets/images/icon.png",
    "scheme": "recordos",
    "userInterfaceStyle": "automatic",
    "ios": {
      "icon": {
        "light": "./assets/images/icon.png",
        "dark": "./assets/images/ios-icon-dark.png",
        "tinted": "./assets/images/ios-icon-tinted.png"
      },
      "bundleIdentifier": "com.recordos.app",
      "buildNumber": "18",
      "associatedDomains": [
        "applinks:test-web.userecordos.com"
      ],
      "infoPlist": {
        "ITSAppUsesNonExemptEncryption": false,
        "CADisableMinimumFrameDurationOnPhone": true,
        "NSLocationWhenInUseUsageDescription": "Allow RecordOS to drop a pin where you are.",
        "NSPhotoLibraryUsageDescription": "Allow RecordOS to attach a photo you choose to an entry.",
        "NSCameraUsageDescription": "Allow RecordOS to photograph a receipt and attach it to an entry."
      }
    },
    "android": {
      "adaptiveIcon": {
        "backgroundColor": "#0F0F0F",
        "foregroundImage": "./assets/images/android-icon-foreground.png",
        "backgroundImage": "./assets/images/android-icon-background.png",
        "monochromeImage": "./assets/images/android-icon-monochrome.png"
      },
      "predictiveBackGestureEnabled": false,
      "package": "com.recordos.app",
      "versionCode": 19,
      "permissions": [
        "android.permission.ACCESS_COARSE_LOCATION",
        "android.permission.ACCESS_FINE_LOCATION",
        "android.permission.CAMERA",
        "android.permission.READ_MEDIA_IMAGES",
        "android.permission.RECORD_AUDIO",
        "android.permission.MODIFY_AUDIO_SETTINGS",
        "android.permission.FOREGROUND_SERVICE",
        "android.permission.FOREGROUND_SERVICE_MEDIA_PLAYBACK"
      ],
      "intentFilters": [
        {
          "action": "VIEW",
          "autoVerify": true,
          "data": [
            {
              "scheme": "https",
              "host": "test-web.userecordos.com",
              "pathPrefix": "/join"
            }
          ],
          "category": [
            "BROWSABLE",
            "DEFAULT"
          ]
        }
      ]
    },
    "web": {
      "output": "static",
      "favicon": "./assets/images/favicon.png"
    },
    "plugins": [
      "expo-router",
      "./plugins/with-theme-colors",
      [
        "expo-splash-screen",
        {
          "backgroundColor": "#0F0F0F",
          "image": "./assets/images/splash-icon.png",
          "imageWidth": 160,
          "dark": {
            "backgroundColor": "#0F0F0F"
          }
        }
      ],
      [
        "expo-font",
        {
          "fonts": [
            "./assets/fonts/Inter-Regular.ttf",
            "./assets/fonts/Inter-Medium.ttf",
            "./assets/fonts/Inter-SemiBold.ttf",
            "./assets/fonts/Sora-Regular.ttf",
            "./assets/fonts/Sora-Medium.ttf",
            "./assets/fonts/Sora-SemiBold.ttf"
          ],
          "android": {
            "fonts": [
              {
                "fontFamily": "Inter",
                "fontDefinitions": [
                  {
                    "path": "./assets/fonts/Inter-Regular.ttf",
                    "weight": 400
                  },
                  {
                    "path": "./assets/fonts/Inter-Medium.ttf",
                    "weight": 500
                  },
                  {
                    "path": "./assets/fonts/Inter-SemiBold.ttf",
                    "weight": 600
                  }
                ]
              },
              {
                "fontFamily": "Sora",
                "fontDefinitions": [
                  {
                    "path": "./assets/fonts/Sora-Regular.ttf",
                    "weight": 400
                  },
                  {
                    "path": "./assets/fonts/Sora-Medium.ttf",
                    "weight": 500
                  },
                  {
                    "path": "./assets/fonts/Sora-SemiBold.ttf",
                    "weight": 600
                  }
                ]
              }
            ]
          }
        }
      ],
      "@react-native-community/datetimepicker",
      "expo-secure-store",
      "expo-sqlite",
      [
        "expo-location",
        {
          "locationWhenInUsePermission": "Allow RecordOS to drop a pin where you are."
        }
      ],
      [
        "expo-image-picker",
        {
          "photosPermission": "Allow RecordOS to use a photo or a file you choose, such as your profile photo, a logo or an attachment.",
          "cameraPermission": "Allow RecordOS to photograph a receipt and attach it to an entry."
        }
      ],
      [
        "expo-audio",
        {
          "microphonePermission": "Allow RecordOS to hear you when you talk to Coach, dictate a message, or set up a business by voice."
        }
      ],
      [
        "react-native-audio-api",
        {
          "iosMicrophonePermission": "Allow RecordOS to hear you when you talk to Coach, dictate a message, or set up a business by voice.",
          "iosBackgroundMode": false
        }
      ],
      [
        "@react-native-google-signin/google-signin",
        {
          "iosUrlScheme": "com.googleusercontent.apps.901023575244-q54a9inj120musdsmdvv56jftvgkb5kh"
        }
      ],
      [
        "@sentry/react-native/expo",
        {
          "url": "https://sentry.io/",
          "organization": "ekeekaran-ventures",
          "project": "record-os-mobile"
        }
      ]
    ],
    "experiments": {
      "typedRoutes": true,
      "reactCompiler": true
    },
    "extra": {
      "router": {},
      "eas": {
        "projectId": "cfbb29f4-c237-4aa7-bf14-b3ad7794b249"
      }
    }
  }
}
